import { request } from "../utils/request";
//登录
import { versionfn } from "../utils/version";
var version = versionfn.version;
export function Login(data) {
  return request({
    url: "/login",
    method: "post",
    data,
    skipAuth: true,
  });
}
//验证码
export function securityCode(data) {
  return request({
    url: `${version}/securityCode`,
    method: "post",
    responseType: "arraybuffer",
    data,
    skipAuth: true,
  });
}
// 获取谷歌验证器二维码
export function GoogleQr(name, secretKey, authToken) {
  return request({
    url: `${version}/getGoogleAuthQrcode`,
    method: "get",
    params: {
      name,
      secretKey,
    },
    responseType: "blob",
    authToken,
  });
}
// 绑定谷歌验证码
export function bindingverCode(code, secretKey, authToken) {
  return request({
    url: `${version}/bindingGoogleAuthCode?code=${code}&secretKey=${secretKey}`,
    method: "post",
    authToken,
  });
}
// 校验谷歌验证码
export function checkverCode(code, authToken) {
  return request({
    url: `${version}/checkGoogleAuthCode?code=${code}`,
    method: "post",
    authToken,
  });
}
// 重置谷歌验证码
export function clearverCode(userId) {
  return request({
    url: `${version}/clearGoogleAuthCode?userId=${userId}`,
    method: "post",
  });
}
// 滑块验证码校验
export function gentCaptcha(data) {
  return request({
    url: `${version}/verifyIntelligentCaptcha`,
    method: "post",
    data,
    skipAuth: true,
  });
}
// 注册
export function Register(data) {
  return request({
    url: `${version}/channelUser/register`,
    method: "post",
    data,
    skipAuth: true,
  });
}
// 发送邮箱验证码
export function emailCode(data) {
  return request({
    url: `${version}/email/securityCode`,
    method: "post",
    data,
    skipAuth: true,
  });
}
// 邮箱注册
export function emailRegister(data) {
  return request({
    url: `${version}/channelUser/email/register`,
    method: "post",
    data,
    skipAuth: true,
  });
}
//修改密码
export function modifyPassword(data) {
  return request({
    url: `${version}/user/modifyPassword`,
    method: "put",
    data,
  });
}
// 无糖浏览器认证 - 用 access_token 换图链 JWT
export function nosugarAuth(data) {
  return request({
    url: `${version}/nosugar/auth`,
    method: "post",
    data,
    skipAuth: true,
  });
}

// 无糖浏览器 Web 登录页专用接口
export function browserLogin(data) {
  return request({
    url: `${version}/user/browser/login`,
    method: "post",
    data,
    skipAuth: true,
  });
}
